/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:41:30
 * @LastEditTime: 2023-03-01 16:54:29
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\alias-manage\index.js
 * 别名管理路由
 */
import aliasLibraryRouter from './modules/aliasLibraryRouter'
const aliasManageRouter = [].concat(aliasLibraryRouter)
export default aliasManageRouter
